"use client";

import { useTrans } from "@/utils/useTrans";
import { ReferralSaleTimer } from "@/components/banner/BannerTimer";
import Link from "next/link";
import { useRouter } from "next/router";
import { useReferral } from "@/hooks/useReferral";

function Banner({ percentile }: { percentile: string }) {
  const { t } = useTrans(["gnb"]);

  return (
    <div className="bg-green-50 px-4 text-base font-600 text-white">
      <div className="mx-auto flex max-w-screen-max items-center justify-between gap-x-1 py-4">
        <div className="flex flex-nowrap gap-x-1">
          <p>{t("Referral Special")}</p>
          <p className="block laptop:hidden">{percentile}</p>
        </div>
        <div className="hidden laptop:block">
          <p>
            {t(
              "Dive into immersive haptic experience with percentile exclusive discount!",
              {
                percentile,
                defaultValue: `Dive into immersive haptic experience with ${percentile} exclusive discount!`,
              },
            )}
          </p>
        </div>
        <ReferralSaleTimer />
      </div>
    </div>
  );
}

export default function ReferralBanner() {
  const { pathname } = useRouter();
  const { percentile } = useReferral();

  if (percentile === null) {
    return null;
  }

  if (!pathname.startsWith("/tactsuit")) {
    return (
      <Link href={"/tactsuit"}>
        <Banner percentile={percentile} />
      </Link>
    );
  }

  return <Banner percentile={percentile} />;
}
